<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数据类型">
					<el-select v-model="dataType" placeholder="请选择数据类型" >
						<el-option label="分钟" value="minute"></el-option>
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight" 
			  size="small"  ref="table">
			<el-table-column type="index" label="序号"></el-table-column>
			<el-table-column prop="time" label="监测时间">
				<template slot-scope="scope">
					<span  v-if="chooseDataType=='day'">
						{{scope.row.time.split(" ")[0]}}
					</span>
					<span v-else>
						{{scope.row.time}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="n00004" label="昼数据" v-if="chooseDataType=='day'">
				<template slot-scope="scope">
					<span v-if="scope.row.n00004>scope.row.dayLimitVal" class="outLimitWord">
						{{scope.row.n00004}}
					</span>
					<span v-else>
						{{scope.row.n00004}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="n00005" label="夜数据" v-if="chooseDataType=='day'">
				<template slot-scope="scope">
					<span v-if="scope.row.n00005>scope.row.nightLimitVal" class="outLimitWord">
						{{scope.row.n00005}}
					</span>
					<span v-else>
						{{scope.row.n00005}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="n00001" label="噪声值" v-if="chooseDataType!='day'"></el-table-column>
			<el-table-column  label="录音" >
                <template slot-scope="scope">
                    <span v-if="scope.row.noiseFiles!=undefined&&scope.row.noiseFiles.length>0"  style="cursor: pointer;" >
                        <el-button type="text" plain  icon="el-icon-view" v-on:click="queryRecord(scope.$index, scope.row)">查看录音</el-button>
                    </span>
                    <span v-else >-</span>
                </template>
            </el-table-column>
			<!-- <el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="small" @click="getFactorNoise(scope.$index, scope.row)">查看频谱</el-button>
				</template>
			</el-table-column>   todo   设备未存在此功能，等后边在进行添加 接口目前为.net-->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" 
			:page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<el-dialog  title="详情" :visible.sync="deviceDataVisible" :close-on-click-modal="true">
            <el-table :data="recordList" border  highlight-current-row v-loading="listLoading"  style="width: 100%;" :max-height="formHeight"   size="small" >
                <el-table-column type="index" label="序号"  ></el-table-column>
                <el-table-column prop="starttime" label="时间"     ></el-table-column>
                <el-table-column   label="异常噪声"  >
                    <template slot-scope="scope">
                        <audio :src="scope.row.filePath" controls="controls"></audio>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

		<el-dialog title="频谱数据查看" :visible.sync="formVisible" id="dialog"  top="8vh" :close-on-click-modal="false">
			<div style="width:100%;height:80%"  id="noiseSpectrum"  ></div>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectExceedData,getFactorNoise,getNoiseSpectrum} from '../../api/api';
	import {formatDate} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'

	import * as echarts from "echarts";

	export default {
	components: { myButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				devices:[],
				projects:[],
				formHeight:0,
				dataType:'minute',
				chooseDataType:'minute',

				type:sessionStorage.getItem("type"),
				recordList:[],
				deviceDataVisible:false,
				formVisible:false,
				factorMap:new Map(),
				facList:[],
				charts:null,
				choosemn:""
			}
			
		},
		watch: {
			dataList(val) {
				this.doLayout();
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}
			},
			doLayout(){
				let that = this
				this.$nextTick(() => {
					that.$refs.table.doLayout()
				})
			},
			getFactorNoise(i,row){ 
				if(this.factorMap.size>0){
					this.getNoiseSpectrum(row);
					return;
				}
				getFactorNoise({}).then((res) => {
					var factor = res.data;
					for (let i = 0; i < factor.length; i++) {
						this.factorMap.set(factor[i].Code,factor[i].Name);
						this.facList.push(factor[i].Code);
					}
					this.getNoiseSpectrum(row);
				});
			},
			getNoiseSpectrum(row){
				//需要修改结束时间
				let para = {
					mn:this.choosemn,
					starttime:row.starttime,
					time:row.time,
                };
				getNoiseSpectrum(para).then((res) => {
					if(res.data.result=="false"){
                        this.$message({
                            message: "查询出错，请重试",
                            type: 'error'
                        })
						return;
                    }
					var data = res.data.realDatas;
					if(data.length==0){
						this.$message({
							message: "时间段内暂无频谱数据",
							type: 'warning'
						})
						return;
					}
					this.formVisible=true;
					var timer=null;
					clearInterval(timer);
					var _this=this;
					timer=setInterval(function(){
						var dom=document.getElementById("noiseSpectrum");
						if(dom!=null&&dom!=undefined){
							clearInterval(timer);
							_this.dradChart(data);
						}
					},10)
				});
			},
			dradChart(data){
				document.getElementById("noiseSpectrum").style.height="80%";
				var i=0;
				var _this=this;
				var yData=[];
				var xData=[];
				var facChoose=[];
				_this.facList.forEach(element => {
					var value=data[i][element];
					if(value==null||value==undefined) {
						
					}else{
						yData.push(value);
						facChoose.push(element);
						xData.push(this.factorMap.get(element));
					}
				});
				
				let option = {
					color: ['#66b1ff'],
					tooltip: { trigger: 'axis' },
					xAxis: { data: xData},
					yAxis:  { type: 'value'},
					series:  {  type: 'bar',data: yData }
				}

				_this.charts = echarts.init(document.getElementById("noiseSpectrum"));
				_this.charts.setOption(option);

				var timer=null;
				clearInterval(timer);
				i=1;
				timer=setInterval(function(){
					if(i>=data.length-1){
						clearInterval(timer);
					}
					yData=[];
					facChoose.forEach(element => {
						var value=data[i][element];
						yData.push(value);
					});
					option.series.data=yData;
					_this.charts.setOption(option)
					i++;
				},1000)
			},
			queryRecord(i,row){
				this.recordList=row.noiseFiles;

				//处理录音文件位置
				for (let index = 0; index <  this.recordList.length; index++) {
					const element =  this.recordList[index];
					element.filePath=window.configuration.resourceUrlJava+"recording/"+this.choosemn+"/"+element.filefoldername+"/"+element.filename;
					
				}
				this.deviceDataVisible=true;
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取历史数据信息
			getDataList(){
				this.type=sessionStorage.getItem("type");
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					var day=188;
					if(this.dataType=="minute"){
						day=99;
					}
					if(this.dataType=="day"){
						day=730;
					}
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>day){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}
                }
				let para = {
					dataType:this.dataType,
					page: this.page,
					limit:this.pageSize,
                    mn: this.filters.mn,
					startTime: starttime,
                    endTime: endtime
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
				selectExceedData(para).then((res) => {
					this.listLoading = false;
					this.choosemn=this.filters.mn;

					if(res.data.code!=0){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
						return;
                    }

					this.chooseDataType=this.dataType;
					this.total = res.data.count;
					this.dataList = res.data.data;
				});
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
				this.dataType="minute";
				start.setTime(start.setHours(start.getHours()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			},
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		}
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }

	.dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
	.tabSelect{
		color: #fff;
		background: #409eff;
	}

	.el-table .outLimitWord{
      color: #daa520;
      font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// OutLimitData.vue?914d6a30